import { render, staticRenderFns } from "./TownLayoutLab.vue?vue&type=template&id=5e07fda9&scoped=true"
import script from "./TownLayoutLab.vue?vue&type=script&lang=js"
export * from "./TownLayoutLab.vue?vue&type=script&lang=js"
import style0 from "./TownLayoutLab.vue?vue&type=style&index=0&id=5e07fda9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e07fda9",
  null
  
)

export default component.exports